module.exports = __webpack_public_path__ + "6b976f1966e7147823c54b4c6d4216e1.pdf";